// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-video {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  --v-video-aspect-ratio: 1.7777777778;
  --v-video-controls-height: 58px;
  --v-video-controls-pill-border-radius: 99px;
}
:where(.vuetify-styles) .v-video--density-default {
  --v-video-controls-height: 58px;
}

:where(.vuetify-styles) .v-video--density-comfortable {
  --v-video-controls-height: 50px;
}

:where(.vuetify-styles) .v-video--density-compact {
  --v-video-controls-height: 42px;
}

:where(.vuetify-styles) .v-video__video {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}
:where(.vuetify-styles) .v-video__video::-webkit-media-controls {
  display: none !important;
}
:where(.vuetify-styles) .v-video__video ~ * {
  z-index: 1;
}
:where(.vuetify-styles) .v-video__header {
  position: relative;
  opacity: 0;
  transition: opacity 0.6s ease-in-out;
  pointer-events: none;
}
:where(.vuetify-styles) .v-video__header > * {
  pointer-events: auto;
}
:where(.vuetify-styles) .v-video__content {
  position: relative;
  cursor: pointer;
  border-radius: inherit;
  z-index: 0;
}
:where(.vuetify-styles) .v-video__content {
  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-video:not(.v-video--idle) .v-video__content .v-video__overlay-fill, :where(.vuetify-styles) .v-video:not(.v-video--idle) .v-video__content .v-video__overlay-fill > * {
  pointer-events: none;
}
:where(.vuetify-styles) .v-video__overlay-fill {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
}
:where(.vuetify-styles) .v-video__overlay-fill > .v-img {
  position: absolute;
  border-radius: inherit;
  inset: 0;
}
:where(.vuetify-styles) .v-video:has(.v-video-controls:not(.v-video-controls--detached)) .v-video__content .v-video__overlay-fill {
  padding-bottom: var(--v-video-controls-height);
}
:where(.vuetify-styles) .v-video__center-icon.v-icon-btn {
  border: 5px solid currentColor;
  opacity: 0.6;
  transition-property: transform, opacity;
  transition-duration: 0.28s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-video__content:hover .v-video__center-icon {
  transform: scale(1.05);
  opacity: 1;
}
:where(.vuetify-styles) .v-video-volume--inline {
  display: flex;
  align-items: center;
}
:where(.vuetify-styles) .v-video-volume__menu {
  background: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-on-surface));
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
:where(.vuetify-styles) .v-video-volume__menu {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: thin;
}
:where(.vuetify-styles) .v-video-volume__menu--border {
  border-width: thin;
  box-shadow: none;
}
:where(.vuetify-styles) .v-video-volume__menu {
  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-video-volume__menu {
  border-radius: 4px;
}
:where(.vuetify-styles) .v-video-volume__menu:has(.v-input--horizontal) {
  height: 40px;
}
:where(.vuetify-styles) .v-video-volume__menu:has(.v-input--vertical) {
  width: 40px;
}
:where(.vuetify-styles) .v-video-volume__menu .v-slider.v-input--horizontal {
  margin: 0 16px;
  width: 100px;
  height: 40px;
}
:where(.vuetify-styles) .v-video-volume__menu .v-slider.v-input--vertical {
  margin: 16px 0;
  height: 100px;
  width: 40px;
}
:where(.vuetify-styles) .v-video-volume__menu .v-slider.v-input--vertical > .v-input__control {
  min-height: 50px;
}
:where(.vuetify-styles) .v-video__track {
  position: relative;
  z-index: 1;
}
:where(.vuetify-styles) .v-video__track.v-slider.v-input--horizontal > .v-input__control {
  min-height: 4px;
}
:where(.vuetify-styles) .v-video__track .v-slider-thumb:not(:hover) .v-slider-thumb__label {
  opacity: 0;
  transition-delay: 0.2s;
}
:where(.vuetify-styles) .v-video__track .v-slider-thumb__label {
  color: rgb(var(--v-theme-on-surface-variant)) !important;
}
:where(.vuetify-styles) .v-video__time {
  font-size: 0.875rem;
  line-height: 1;
  letter-spacing: 0.02em;
}
:where(.vuetify-styles) .v-video--variant-player {
  width: 100%;
}
:where(.vuetify-styles) .v-video--variant-player > .v-video__content {
  width: 100%;
  aspect-ratio: var(--v-video-aspect-ratio);
}
:where(.vuetify-styles) .v-video--variant-background {
  outline: none;
  position: absolute;
  inset: 0;
  pointer-events: none;
}
:where(.vuetify-styles) .v-video--variant-background > .v-video__content {
  width: 100%;
  height: 100%;
}
:where(.vuetify-styles) .v-video-controls {
  --v-background-opacity: 0.8;
  --v-video-controls-gap: 16px;
  --v-video-controls-pill-height: 42px;
  flex: 1 0 100%;
  align-self: stretch;
  padding: 8px;
  display: flex;
  align-items: center;
  position: relative;
  gap: var(--v-video-controls-gap);
  min-height: var(--v-video-controls-height);
  backdrop-filter: blur(5px);
  background-color: rgba(var(--v-theme-surface), var(--v-background-opacity));
  color: rgb(var(--v-theme-on-surface));
  width: 100%;
  opacity: 0;
}
:where(.vuetify-styles) .v-video-controls--density-default {
  --v-video-controls-gap: 16px;
}

:where(.vuetify-styles) .v-video-controls--density-comfortable {
  --v-video-controls-gap: 12px;
}

:where(.vuetify-styles) .v-video-controls--density-compact {
  --v-video-controls-gap: 8px;
}

:where(.vuetify-styles) .v-video-controls, :where(.vuetify-styles) .v-video-controls--pills > .v-video-control__pill {
  transition: 0.6s ease-in-out;
  transition-property: opacity, background-color;
}
:where(.vuetify-styles) .v-video-controls--pills > .v-video-control__pill {
  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-video-controls:hover {
  --v-background-opacity: 1;
}
:where(.vuetify-styles) .v-video-controls .v-video__track {
  width: auto;
}
:where(.vuetify-styles) .v-video-controls .v-video-control__pill {
  display: flex;
  align-items: center;
  gap: 8px;
}
:where(.vuetify-styles) .v-video-controls--pills {
  --v-background-opacity: 1;
  --v-video-controls-height: calc(var(--v-video-controls-pill-height) + 24px);
  backdrop-filter: none;
  pointer-events: none;
}
:where(.vuetify-styles) .v-video-controls--pills > * {
  pointer-events: auto;
}
:where(.vuetify-styles) .v-video-controls--pills:not(:empty) {
  background: transparent;
}
:where(.vuetify-styles) .v-video-controls--pills > .v-video-control__pill {
  backdrop-filter: blur(5px);
  background: rgba(var(--v-theme-surface), var(--v-background-opacity));
  border-radius: var(--v-video-controls-pill-border-radius);
  min-height: var(--v-video-controls-pill-height);
  min-width: var(--v-video-controls-pill-height);
  padding: 0 6px;
  z-index: 1;
}
:where(.vuetify-styles) .v-video-controls--pills > .v-video-control__pill > .v-icon-btn {
  border-radius: inherit;
}
:where(.vuetify-styles) .v-video-controls--pills > .v-video-control__pill:empty {
  display: none;
}
:where(.vuetify-styles) .v-video-controls--pills > .v-video-control__pill:has(> *:only-child) {
  padding-inline: 0;
  justify-content: center;
  border-radius: var(--v-video-controls-pill-border-radius);
}
:where(.vuetify-styles) .v-video-controls--pills > .v-video__time {
  padding: 0 16px;
}
:where(.vuetify-styles) .v-video-controls--variant-tube .v-slider.v-video__track {
  position: absolute;
  top: -8px;
  left: 0;
  right: 0;
}
:where(.vuetify-styles) .v-video-controls--variant-tube .v-slider.v-video__track .v-slider-track {
  height: calc(var(--v-slider-track-size) + 10px);
}
:where(.vuetify-styles) .v-video-controls--variant-tube .v-slider.v-video__track .v-slider-track__fill {
  height: var(--v-slider-track-size);
}
:where(.vuetify-styles) .v-video-controls--split-time {
  padding-inline: 20px;
}
:where(.vuetify-styles) .v-video-controls:not(.v-video-controls--detached) {
  margin-top: calc(-1 * var(--v-video-controls-height));
}
:where(.vuetify-styles) .v-video-controls:not(.v-video-controls--floating) {
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}
:where(.vuetify-styles) .v-video-controls:not(.v-video-controls--floating):not(.v-video-controls--pills) {
  border-top: thin solid rgba(var(--v-theme-surface-variant), 0.2);
}
:where(.vuetify-styles) .v-video-controls--floating {
  --v-background-opacity: 1;
  border-radius: inherit;
  margin-inline: 12px;
  width: calc(100% - 2 * 12px);
}
:where(.vuetify-styles) .v-video-controls--floating:not(.v-video-controls--detached) {
  margin-top: calc(-1 * var(--v-video-controls-height) - 12px);
  margin-bottom: 12px;
}
:where(.vuetify-styles) .v-video-controls--detached {
  --v-background-opacity: 1;
  position: relative;
  margin-block-start: 12px;
  padding-inline: 12px;
  backdrop-filter: none;
  border-top: none;
  border-radius: inherit;
  opacity: 1;
}
:where(.vuetify-styles) .v-video-controls--detached:not(.v-video-controls--pills) {
  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-video:not(.v-video--playing) .v-video__header,
:where(.vuetify-styles) .v-video:not(.v-video--playing) .v-video-controls,
:where(.vuetify-styles) .v-video:hover .v-video__header,
:where(.vuetify-styles) .v-video:hover .v-video-controls {
  opacity: 1;
}
:where(.vuetify-styles) .v-video--rounded {
  border-radius: 4px;
}
:where(.vuetify-styles) .v-video:fullscreen .v-video__content {
  min-height: 100% !important;
  min-width: 100% !important;
}
:where(.vuetify-styles) .v-video:fullscreen .v-video-controls {
  position: absolute;
  bottom: 0;
  z-index: 2147483647;
}
:where(.vuetify-styles) .v-video:fullscreen .v-video-controls--floating {
  bottom: 12px;
}

:where(.vuetify-styles) .poster-fade-out-leave-active {
  transition: opacity 1s linear 0.3s;
}
:where(.vuetify-styles) .poster-fade-out-leave-to {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/labs/VVideo/VVideo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,+BAA+B;EAC/B,2CAA2C;AAC7C;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oCAAoC;EACpC,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,wOAAwO;AAC1O;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8BAA8B;EAC9B,YAAY;EACZ,uCAAuC;EACvC,0BAA0B;EAC1B,wDAAwD;AAC1D;AACA;EACE,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uOAAuO;AACzO;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;EACd,aAAa;EACb,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,0CAA0C;EAC1C,0BAA0B;EAC1B,2EAA2E;EAC3E,qCAAqC;EACrC,WAAW;EACX,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;AACA;EACE,wOAAwO;AAC1O;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,2EAA2E;EAC3E,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,qEAAqE;EACrE,yDAAyD;EACzD,+CAA+C;EAC/C,8CAA8C;EAC9C,cAAc;EACd,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yDAAyD;AAC3D;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;AACA;EACE,+CAA+C;AACjD;AACA;EACE,kCAAkC;AACpC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qDAAqD;AACvD;AACA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;AACA;EACE,gEAAgE;AAClE;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,4DAA4D;EAC5D,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,wOAAwO;AAC1O;AACA;;;;EAGE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,UAAU;AACZ","sourcesContent":[".v-video {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  --v-video-aspect-ratio: 1.7777777778;\n  --v-video-controls-height: 58px;\n  --v-video-controls-pill-border-radius: 99px;\n}\n.v-video--density-default {\n  --v-video-controls-height: 58px;\n}\n\n.v-video--density-comfortable {\n  --v-video-controls-height: 50px;\n}\n\n.v-video--density-compact {\n  --v-video-controls-height: 42px;\n}\n\n.v-video__video {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 0;\n}\n.v-video__video::-webkit-media-controls {\n  display: none !important;\n}\n.v-video__video ~ * {\n  z-index: 1;\n}\n.v-video__header {\n  position: relative;\n  opacity: 0;\n  transition: opacity 0.6s ease-in-out;\n  pointer-events: none;\n}\n.v-video__header > * {\n  pointer-events: auto;\n}\n.v-video__content {\n  position: relative;\n  cursor: pointer;\n  border-radius: inherit;\n  z-index: 0;\n}\n.v-video__content {\n  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-video:not(.v-video--idle) .v-video__content .v-video__overlay-fill, .v-video:not(.v-video--idle) .v-video__content .v-video__overlay-fill > * {\n  pointer-events: none;\n}\n.v-video__overlay-fill {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: inherit;\n}\n.v-video__overlay-fill > .v-img {\n  position: absolute;\n  border-radius: inherit;\n  inset: 0;\n}\n.v-video:has(.v-video-controls:not(.v-video-controls--detached)) .v-video__content .v-video__overlay-fill {\n  padding-bottom: var(--v-video-controls-height);\n}\n.v-video__center-icon.v-icon-btn {\n  border: 5px solid currentColor;\n  opacity: 0.6;\n  transition-property: transform, opacity;\n  transition-duration: 0.28s;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-video__content:hover .v-video__center-icon {\n  transform: scale(1.05);\n  opacity: 1;\n}\n.v-video-volume--inline {\n  display: flex;\n  align-items: center;\n}\n.v-video-volume__menu {\n  background: rgb(var(--v-theme-surface));\n  color: rgb(var(--v-theme-on-surface));\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.v-video-volume__menu {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: thin;\n}\n.v-video-volume__menu--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-video-volume__menu {\n  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-video-volume__menu {\n  border-radius: 4px;\n}\n.v-video-volume__menu:has(.v-input--horizontal) {\n  height: 40px;\n}\n.v-video-volume__menu:has(.v-input--vertical) {\n  width: 40px;\n}\n.v-video-volume__menu .v-slider.v-input--horizontal {\n  margin: 0 16px;\n  width: 100px;\n  height: 40px;\n}\n.v-video-volume__menu .v-slider.v-input--vertical {\n  margin: 16px 0;\n  height: 100px;\n  width: 40px;\n}\n.v-video-volume__menu .v-slider.v-input--vertical > .v-input__control {\n  min-height: 50px;\n}\n.v-video__track {\n  position: relative;\n  z-index: 1;\n}\n.v-video__track.v-slider.v-input--horizontal > .v-input__control {\n  min-height: 4px;\n}\n.v-video__track .v-slider-thumb:not(:hover) .v-slider-thumb__label {\n  opacity: 0;\n  transition-delay: 0.2s;\n}\n.v-video__track .v-slider-thumb__label {\n  color: rgb(var(--v-theme-on-surface-variant)) !important;\n}\n.v-video__time {\n  font-size: 0.875rem;\n  line-height: 1;\n  letter-spacing: 0.02em;\n}\n.v-video--variant-player {\n  width: 100%;\n}\n.v-video--variant-player > .v-video__content {\n  width: 100%;\n  aspect-ratio: var(--v-video-aspect-ratio);\n}\n.v-video--variant-background {\n  outline: none;\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n.v-video--variant-background > .v-video__content {\n  width: 100%;\n  height: 100%;\n}\n.v-video-controls {\n  --v-background-opacity: 0.8;\n  --v-video-controls-gap: 16px;\n  --v-video-controls-pill-height: 42px;\n  flex: 1 0 100%;\n  align-self: stretch;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  gap: var(--v-video-controls-gap);\n  min-height: var(--v-video-controls-height);\n  backdrop-filter: blur(5px);\n  background-color: rgba(var(--v-theme-surface), var(--v-background-opacity));\n  color: rgb(var(--v-theme-on-surface));\n  width: 100%;\n  opacity: 0;\n}\n.v-video-controls--density-default {\n  --v-video-controls-gap: 16px;\n}\n\n.v-video-controls--density-comfortable {\n  --v-video-controls-gap: 12px;\n}\n\n.v-video-controls--density-compact {\n  --v-video-controls-gap: 8px;\n}\n\n.v-video-controls, .v-video-controls--pills > .v-video-control__pill {\n  transition: 0.6s ease-in-out;\n  transition-property: opacity, background-color;\n}\n.v-video-controls--pills > .v-video-control__pill {\n  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-video-controls:hover {\n  --v-background-opacity: 1;\n}\n.v-video-controls .v-video__track {\n  width: auto;\n}\n.v-video-controls .v-video-control__pill {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.v-video-controls--pills {\n  --v-background-opacity: 1;\n  --v-video-controls-height: calc(var(--v-video-controls-pill-height) + 24px);\n  backdrop-filter: none;\n  pointer-events: none;\n}\n.v-video-controls--pills > * {\n  pointer-events: auto;\n}\n.v-video-controls--pills:not(:empty) {\n  background: transparent;\n}\n.v-video-controls--pills > .v-video-control__pill {\n  backdrop-filter: blur(5px);\n  background: rgba(var(--v-theme-surface), var(--v-background-opacity));\n  border-radius: var(--v-video-controls-pill-border-radius);\n  min-height: var(--v-video-controls-pill-height);\n  min-width: var(--v-video-controls-pill-height);\n  padding: 0 6px;\n  z-index: 1;\n}\n.v-video-controls--pills > .v-video-control__pill > .v-icon-btn {\n  border-radius: inherit;\n}\n.v-video-controls--pills > .v-video-control__pill:empty {\n  display: none;\n}\n.v-video-controls--pills > .v-video-control__pill:has(> *:only-child) {\n  padding-inline: 0;\n  justify-content: center;\n  border-radius: var(--v-video-controls-pill-border-radius);\n}\n.v-video-controls--pills > .v-video__time {\n  padding: 0 16px;\n}\n.v-video-controls--variant-tube .v-slider.v-video__track {\n  position: absolute;\n  top: -8px;\n  left: 0;\n  right: 0;\n}\n.v-video-controls--variant-tube .v-slider.v-video__track .v-slider-track {\n  height: calc(var(--v-slider-track-size) + 10px);\n}\n.v-video-controls--variant-tube .v-slider.v-video__track .v-slider-track__fill {\n  height: var(--v-slider-track-size);\n}\n.v-video-controls--split-time {\n  padding-inline: 20px;\n}\n.v-video-controls:not(.v-video-controls--detached) {\n  margin-top: calc(-1 * var(--v-video-controls-height));\n}\n.v-video-controls:not(.v-video-controls--floating) {\n  border-bottom-left-radius: inherit;\n  border-bottom-right-radius: inherit;\n}\n.v-video-controls:not(.v-video-controls--floating):not(.v-video-controls--pills) {\n  border-top: thin solid rgba(var(--v-theme-surface-variant), 0.2);\n}\n.v-video-controls--floating {\n  --v-background-opacity: 1;\n  border-radius: inherit;\n  margin-inline: 12px;\n  width: calc(100% - 2 * 12px);\n}\n.v-video-controls--floating:not(.v-video-controls--detached) {\n  margin-top: calc(-1 * var(--v-video-controls-height) - 12px);\n  margin-bottom: 12px;\n}\n.v-video-controls--detached {\n  --v-background-opacity: 1;\n  position: relative;\n  margin-block-start: 12px;\n  padding-inline: 12px;\n  backdrop-filter: none;\n  border-top: none;\n  border-radius: inherit;\n  opacity: 1;\n}\n.v-video-controls--detached:not(.v-video-controls--pills) {\n  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-video:not(.v-video--playing) .v-video__header,\n.v-video:not(.v-video--playing) .v-video-controls, .v-video:hover .v-video__header,\n.v-video:hover .v-video-controls {\n  opacity: 1;\n}\n.v-video--rounded {\n  border-radius: 4px;\n}\n.v-video:fullscreen .v-video__content {\n  min-height: 100% !important;\n  min-width: 100% !important;\n}\n.v-video:fullscreen .v-video-controls {\n  position: absolute;\n  bottom: 0;\n  z-index: 2147483647;\n}\n.v-video:fullscreen .v-video-controls--floating {\n  bottom: 12px;\n}\n\n.poster-fade-out-leave-active {\n  transition: opacity 1s linear 0.3s;\n}\n.poster-fade-out-leave-to {\n  opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
